/**
 * Zentrale Definition aller API-Pfade.
 * CommonJS-Format damit die Datei sowohl in vue.config.js (Node.js)
 * als auch in config.js (webpack) verwendet werden kann.
 * Neue Endpunkte hier eintragen – Proxy und Config werden automatisch aktualisiert.
 */
module.exports = {
  API:            '/api',
  TOR:            '/tor',
  COMM:           '/communication-api',
  APP:            '/app-api',
  PUBLIC:         '/app-public',
  GRAPH:          '/graph-api',
  CRM:            '/crm-api',
  PORTAL:         '/portal-api',
  VISUAL_PLANNER: '/visual-planner-api',
  PDFGENERATOR:   '/pdfgenerator',
  EXPORT:         '/export',
  PERMISSIONS:    '/permissions',
  AUSWAHLWERTE:   '/selection-values',
  QUESTIONAIRE:   '/umfrage',
  CARBONE:        '/carbone-api',
  KOTLIN:         '/kotlin-api',
  REGEL:          '/regel',
  LEITSYSTEM:     '/apileitsystem',
  // Nicht-API-Pfade die ebenfalls proxied werden müssen
  LOGIN:          '/login',
  LOGOUT:         '/logout',
  MEDIA:          '/media',
};
